/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Field_YearInputs */

const en_field_year = /** @type {(inputs: Field_YearInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Year`)
};

const es_field_year = /** @type {(inputs: Field_YearInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Año`)
};

const fr_field_year = /** @type {(inputs: Field_YearInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Année`)
};

const de_field_year = /** @type {(inputs: Field_YearInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jahr`)
};

const ja_field_year = /** @type {(inputs: Field_YearInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`年`)
};

const zh_field_year = /** @type {(inputs: Field_YearInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`年份`)
};

const ar_field_year = /** @type {(inputs: Field_YearInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`السنة`)
};

const id_field_year = /** @type {(inputs: Field_YearInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tahun`)
};

const it_field_year = /** @type {(inputs: Field_YearInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anno`)
};

const ru_field_year = /** @type {(inputs: Field_YearInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Год`)
};

const pt_field_year = /** @type {(inputs: Field_YearInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ano`)
};

const ko_field_year = /** @type {(inputs: Field_YearInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`연도`)
};

/**
* | output |
* | --- |
* | "Year" |
*
* @param {Field_YearInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const field_year = /** @type {((inputs?: Field_YearInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Field_YearInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_field_year(inputs)
	if (locale === "es") return es_field_year(inputs)
	if (locale === "fr") return fr_field_year(inputs)
	if (locale === "de") return de_field_year(inputs)
	if (locale === "ja") return ja_field_year(inputs)
	if (locale === "zh") return zh_field_year(inputs)
	if (locale === "ar") return ar_field_year(inputs)
	if (locale === "id") return id_field_year(inputs)
	if (locale === "it") return it_field_year(inputs)
	if (locale === "ru") return ru_field_year(inputs)
	if (locale === "pt") return pt_field_year(inputs)
	return ko_field_year(inputs)
});